import type { ConstructionTimelinePhase } from "../types";

/** Subcontractor portal submission bundle (same slots as `BeneficiaryPhaseProgress`). */
export type PhasePortalPhotoBundle = {
  photo1: string | null;
  photo2?: string | null;
  photo3?: string | null;
};

function xmlEscape(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;");
}

function svgPlaceholder(phaseTitle: string, slot: 1 | 2 | 3, rowHue: number): string {
  const slotShift = slot === 1 ? 0 : slot === 2 ? 18 : -14;
  const h = ((((rowHue + slotShift) % 360) + 360) % 360);
  const title = xmlEscape(phaseTitle.trim().slice(0, 28) || "Phase");
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="200" height="140" viewBox="0 0 200 140">
<rect fill="hsl(${h} 48% 88%)" width="200" height="140"/>
<rect x="12" y="12" width="176" height="116" rx="6" fill="hsl(${h} 42% 96%)" stroke="hsl(${h} 35% 70%)" stroke-width="1.5"/>
<text x="100" y="58" text-anchor="middle" font-family="system-ui,Segoe UI,sans-serif" font-size="12" font-weight="700" fill="#0f172a">${title}</text>
<text x="100" y="82" text-anchor="middle" font-family="system-ui,Segoe UI,sans-serif" font-size="11" fill="#475569">Sample portal photo ${slot}</text>
<text x="100" y="104" text-anchor="middle" font-family="system-ui,Segoe UI,sans-serif" font-size="9.5" fill="#64748b">Timeline master preview only</text>
</svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

/** Demo images for the timeline master Gantt (not real site photos). */
export function buildSamplePortalPhotosForTimelineMaster(
  phases: ConstructionTimelinePhase[],
): Partial<Record<string, PhasePortalPhotoBundle>> {
  const out: Partial<Record<string, PhasePortalPhotoBundle>> = {};
  for (let i = 0; i < phases.length; i += 1) {
    const p = phases[i];
    const hue = (i * 47) % 360;
    out[p.id] = {
      photo1: svgPlaceholder(p.title, 1, hue),
      photo2: svgPlaceholder(p.title, 2, hue),
      photo3: svgPlaceholder(p.title, 3, hue),
    };
  }
  return out;
}

export function portalPhotoBundleHasImage(b: PhasePortalPhotoBundle | undefined): boolean {
  if (!b) return false;
  return Boolean(
    (b.photo1 && b.photo1.length > 12) ||
      (b.photo2 && b.photo2.length > 12) ||
      (b.photo3 && b.photo3.length > 12),
  );
}
